/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { RouteResource } from '@atlassian/react-resource-router';
import { createProjectPropertyResource } from './createProjectPropertyResource.tsx';

export const csmHubSetupSupportWebsiteResource: RouteResource<Boolean | null> =
	createProjectPropertyResource<Boolean>({
		propertyKey: 'csmHubSetup.supportWebsite',
		maxAge: 0,
	});
